import { CloseOutlined } from '@ant-design/icons';
import { INFO_TTL_MS, INFO_WITH_ACTIONS_TTL_MS } from './constants';
import { useNoticeTimer } from './useNoticeTimer';
import type { Notice } from './types';
import styles from './NoticeStack.module.css';

interface NoticeItemProps {
  notice: Notice;
  onDismiss: (id: number) => void;
}

function getTtl(notice: Notice): number | null {
  if (notice.kind === 'error') return null;
  return notice.actions.length > 0 ? INFO_WITH_ACTIONS_TTL_MS : INFO_TTL_MS;
}

export function NoticeItem({ notice, onDismiss }: NoticeItemProps) {
  const { id, kind, title, items, actions } = notice;
  const handlers = useNoticeTimer(getTtl(notice), () => onDismiss(id));

  return (
    <div
      className={`${styles.notice} ${kind === 'error' ? styles.error : styles.info}`}
      role={kind === 'error' ? 'alert' : 'status'}
      {...handlers}
    >
      <div className={styles.body}>
        <div className={styles.title}>{title}</div>
        {items.length === 1 && <p className={styles.detail}>{items[0]}</p>}
        {items.length > 1 && (
          <ul className={styles.items}>
            {items.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        )}
        {actions.length > 0 && (
          <div className={styles.actions}>
            {actions.map((action) => (
              <button
                key={action.label}
                type="button"
                className={styles.action}
                onClick={() => {
                  action.onClick();
                  onDismiss(id);
                }}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
      <button type="button" className={styles.close} aria-label="Закрыть" onClick={() => onDismiss(id)}>
        <CloseOutlined />
      </button>
    </div>
  );
}
